import { useEffect, useState } from 'react';

import { STORAGE_KEY_APP_TITLE } from 'src/config/storage-keys';
import { useWhitelabelStore } from 'src/store/whitelabel/whitelabel.store';

const DEFAULT_TITLE = 'Nectar';

const getStoredTitle = (): string | null => {
  try {
    return window.localStorage.getItem(STORAGE_KEY_APP_TITLE);
  } catch {
    return null;
  }
};

const persistTitle = (title: string): void => {
  try {
    window.localStorage.setItem(STORAGE_KEY_APP_TITLE, title);
  } catch {
    // Mantém o título funcional quando o armazenamento não estiver disponível.
  }
};

export function useDynamicTitle() {
  const { whitelabel } = useWhitelabelStore();
  const [cachedTitle] = useState<string | null>(getStoredTitle);

  useEffect(() => {
    if (whitelabel?.name) {
      persistTitle(whitelabel.name);
    }
  }, [whitelabel?.name]);

  return { title: whitelabel?.name || cachedTitle || DEFAULT_TITLE };
}
